"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownPopper = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DropdownIcon = require("../DropdownIcon/DropdownIcon");
var _Popper = require("../Popper/Popper");
/**
 * A `Popper` trigger for the `Dropdown` component.
 *
 * @extends Popper
 * @related [`Dropdown`, `Popper`]
 * @since 7.28.0
 */
var DropdownPopper = /*#__PURE__*/(0, _styledComponents.default)(_Popper.Popper).withConfig({
  displayName: "DropdownPopper",
  componentId: "c11n-8-107-0__sc-u1wzgh-0"
})([""]);
exports.DropdownPopper = DropdownPopper;
DropdownPopper.displayName = 'DropdownPopper';
DropdownPopper.propTypes = {
  /**
   * The popper content, usually a `DropdownIcon` or a `DropdownButton`.
   */
  children: _propTypes.default.node,
  /**
   * The `Popper` `offset` prop.
   */
  offset: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func]),
  /**
   * Will close the dropdown when the trigger is no longer visible in the viewport.
   */
  shouldCloseOnViewportLeave: _propTypes.default.bool
};
DropdownPopper.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_DropdownIcon.DropdownIcon, null),
  offset: [0, 8],
  shouldCloseOnViewportLeave: false
};

/** @component */